import * as Yup from "yup";

import { isValidPhone, yupPhoneTransform, PHONE_ERROR } from "../utils/phone";

// Phone is required here and normalised to E.164 on submit (see utils/phone.js),
// so the value we send always passes the server's libphonenumber validation.
const AddPlayerSchema = Yup.object().shape({
  firstName: Yup.string().required("First Name is required"),
  email: Yup.string()
    .required("Email is required")
    .email("Provide a valid email"),
  department: Yup.string().required("Department is required"),
  phoneNumber: Yup.string()
    .transform(yupPhoneTransform)
    .required("Mobile number is required so this player can receive SMS alerts")
    .test("valid-phone", PHONE_ERROR, (value) => !value || isValidPhone(value)),
});

export default AddPlayerSchema;
